import AdminNotificationsShow from "../../components/Notifications/AdminNotificationsShow";
import AdminNotificationsCreate from "../../components/Notifications/AdminNotificationsCreate";
import AdminManuals from "../../components/Notifications/AdminManuals";
import { GetSchoolsForAdmin, GetAvailableProgramLicenses } from "../../actions/adminQueries";
import Pacmanloader from "../../components/Pacmanloader/Pacmanloader";

export default function NotificationsAdministration() {
  const licenseData = GetAvailableProgramLicenses();
  const schoolData = GetSchoolsForAdmin();

  if (schoolData.isPending || !schoolData.data || licenseData.isPending) {
    return <Pacmanloader />;
  }

  return (
    <>
      <AdminManuals />
      <AdminNotificationsCreate
        schoolData={schoolData.data}
        licenseData={licenseData.data ?? []}
      />
      <AdminNotificationsShow
        schoolData={schoolData.data}
        licenseData={licenseData.data ?? []}
      />
    </>
  );
}
